import { render, staticRenderFns } from "./LicitacaoFornecedorTermosHabilitacao.vue?vue&type=template&id=749e47e1"
import script from "./LicitacaoFornecedorTermosHabilitacao.vue?vue&type=script&lang=js"
export * from "./LicitacaoFornecedorTermosHabilitacao.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports